const queryKey = 'rwg_token'
const cookieKey = `_${queryKey}`
const cookieParam = 'max-age=2592000;path=/'

export const readAndSetRwgToken = () => {
  const query = location.search.substring(1)
  const params = query.split('&')

  for (const param of params) {
    const [key, value] = param.split('=')

    if (key === queryKey) {
      const rwgToken = decodeURIComponent(value)
      document.cookie = `${cookieKey}=${rwgToken};${cookieParam}`
      break
    }
  }
}

export const getRwgToken = () => {
  const rwgTokenCookie = document.cookie.split('; ').find((row) => row.startsWith(`${cookieKey}=`))

  if (rwgTokenCookie) {
    return rwgTokenCookie.split('=')[1]
  }
}
